import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Container from "../../components/atoms/Container";
import logo from "../../assets/home/logo-dark.svg";
import {
  scrollToApply,
  useApplyFormInView,
} from "../../components/templates/landing/InstantCash/anchors";

const Header = styled.header`
  position: relative;
  background: #fff;
  box-shadow:
    0px 0.25px 3px 0px rgba(0, 0, 0, 0.04),
    0px 2.75px 9px 0px rgba(0, 0, 0, 0.19);
  & .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--header-height);
    z-index: 999;
  }

  .logo img {
    height: 35px;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .tagline {
    display: none;
  }

  .apply-cta {
    appearance: none;
    background: none;
    border: none;
    cursor: pointer;
    font-family: Spartan;
    font-size: 1.4rem;
    font-weight: 700;
    color: var(--color-primary);
    padding: 0.8rem 0;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid var(--color-primary);
      outline-offset: 3px;
    }
  }

  /* The page themes style \`.header .apply-cta\` from their own scope, which
   * outranks a bare \`.apply-cta\` here — \`&&&\` buys back the specificity so the
   * hidden state survives on all three landers. It also replaces their
   * transition, so the properties they animate on hover are listed here too. */
  &&& .apply-cta {
    transition:
      opacity 0.25s ease,
      transform 0.25s ease,
      visibility 0.25s ease,
      background 0.25s ease,
      border-color 0.2s ease,
      color 0.2s ease;
  }

  /* opacity rather than display: the landers toggle display by breakpoint */
  &&& .apply-cta.is-hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-4px);
  }

  @media screen and (max-width: 600px) {
    .logo img {
      height: 30px;
    }

    .apply-cta {
      font-size: 1.3rem;
    }
  }
`;

const HeaderComponent = ({
  showApplyCta,
  ctaLabel = "Check your status",
  tagline,
}: {
  showApplyCta?: boolean;
  ctaLabel?: string;
  /** small caps strapline shown beside the CTA (v2 lander) */
  tagline?: string;
}) => {
  // the CTA is redundant while the form it scrolls to is already on screen
  const formInView = useApplyFormInView();

  return (
    <Header className="header">
      <Container>
        <div className="wrapper">
          <div className="logo">
            <Link to="/">
              <img
                src={logo}
                alt={`${String(
                  process.env.REACT_APP_TRIBE_NAME,
                ).toLowerCase()}-lending`}
              />
            </Link>
          </div>
          {showApplyCta ? (
            <div className="header-actions">
              {tagline ? <span className="tagline">{tagline}</span> : null}
              <button
                type="button"
                className={`apply-cta${formInView ? " is-hidden" : ""}`}
                onClick={scrollToApply}
                // faded out, so keep it off the tab order and out of the a11y
                // tree as well
                aria-hidden={formInView}
                tabIndex={formInView ? -1 : 0}
              >
                {ctaLabel}
              </button>
            </div>
          ) : null}
        </div>
      </Container>
    </Header>
  );
};

export default HeaderComponent;
